import firebase from "../firebase";
import GENRALHELPERS from "../GENRAL-HELPERS";
import generateHtml from "./generate-html";

class promotedItems {

    constructor() {
        this._windowEvents()
    }

    _windowEvents() {
        window.addEventListener("click", (e) => {

            const isItem = e.target.closest(".promotedItemViewMiniCon1")

            if (isItem) {

                const url = isItem.dataset.openurl

                if (url) {
                    GENRALHELPERS._openOutboundLink(url)
                }
            }
        })
    }

    _chimmerFucntion() {
        // 1️⃣ Inject shimmer CSS dynamically
        const style = document.createElement("style");
        style.innerHTML = `
    .__vp_shimmer {
      position: relative !important;
      overflow: hidden !important;
    }

    .__vp_shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        120deg,
        transparent,
        rgba(255,255,255,0.5),
        transparent
      );
      transform: skewX(-20deg);
      animation: __vp_shimmer_anim 3s infinite;
    }

    @keyframes __vp_shimmer_anim {
      0% { left: -150%; }
      100% { left: 150%; }
    }
  `;
        document.head.appendChild(style);

        // 2️⃣ Observe visibility
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("__vp_shimmer");
                } else {
                    entry.target.classList.remove("__vp_shimmer");
                }
            });
        }, { threshold: 0.4 });

        // 3️⃣ Observe all current buttons
        document.querySelectorAll(".promotedItemViewMiniCon10")
            .forEach(btn => observer.observe(btn));

    }

    async _setHeaderTexts() {
        const header1Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText1Parent")
        const header1 = document.getElementById("NVHeaderConSearchCon2B1PromotedText1")
        const header2Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedCuponParent")
        const header2 = document.getElementById("NVHeaderConSearchCon2B1PromotedCupon")
        const header3Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText2Parent")
        const header3 = document.getElementById("NVHeaderConSearchCon2B1PromotedText2")

        // header1Parent.style.display = 'none'
        // header2Parent.style.display = 'none'
        // header3Parent.style.display = 'none'

        const textData = await firebase._getAnyDocById('adds/promotedItemsTexts')

        console.log(textData);


        if (textData) {
            header1Parent.style.display = 'flex'
            header1.textContent = textData.text1 || 'Productos Promocionados'

            if (textData.textPro) {
                header2Parent.style.display = 'flex'
                header2.textContent = textData.textPro || ''
            }
            if (textData.text2) {
                header3Parent.style.display = 'flex'
                header3.textContent = textData.text2 || ''
            }
        }

    }

    async _renderAll(conId, items, reset = false) {

        if (reset) {
            this._setHeaderTexts()
        }

        setTimeout(() => {
            this._chimmerFucntion()
        }, 5000)
        const renderCon = document.getElementById(conId)

        if (reset) {
            renderCon.innerHTML = ''
        }

        const batchSize = 3;

        for (let i = 0; i < items.length; i += batchSize) {

            const batch = items.slice(i, i + batchSize);

            for (const item of batch) {

                const data = await this._fetchLinkPreviewData(
                    item.url,
                    item.platform
                );
                if (data?.image) {
                    console.warn(data);
                    console.log(data);

                    const html = generateHtml._generateItem(data, item);
                    renderCon.insertAdjacentHTML('beforeend', html);
                }


            }
        }



    }


    async _renderAllV2(conId, items, reset = false) {
        // const ske = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

        // const renderCon = document.getElementById(conId)

        // if (reset) {
        //     renderCon.innerHTML = ''
        //     ske.forEach(skeNum => {
        //         renderCon.insertAdjacentHTML(
        //             'beforeend',
        //             generateHtml._generateSkeleton(skeNum)
        //         )
        //     });

        // }

        for (const item of items) {

            // const skeletonId = `skeleton-${crypto.randomUUID()}`

            // // 1️⃣ Insert skeleton immediately
            // renderCon.insertAdjacentHTML(
            //     'beforeend',
            //     generateHtml._generateSkeleton(skeletonId)
            // )

            // 2️⃣ Fetch data async (no await blocking UI)
            this._fetchLinkPreviewData(item.url, item.platform)
                .then((data) => {

                    if (reset) {
                        renderCon.innerHTML = ''
                    }

                    const html = generateHtml._generateItem(data, item)
                    renderCon.insertAdjacentHTML('beforeend', html)

                    // const skeleton = document.getElementById(skeletonId)

                    // if (skeleton) {
                    //     skeleton.outerHTML = html
                    // }

                })
                .catch(() => {
                    // const skeleton = document.getElementById(skeletonId)
                    // if (skeleton) skeleton.remove()
                })
        }

    }

    async _renderAllV3(conId, items, reset = false) {

        const renderCon = document.getElementById(conId)

        if (reset) {
            renderCon.innerHTML = ''

            // Insert 10 skeletons immediately
            let skeletonHTML = ''
            for (let i = 0; i < 10; i++) {
                skeletonHTML += generateHtml._generateSkeleton()
            }

            renderCon.insertAdjacentHTML('beforeend', skeletonHTML)
        }

        let firstItemRendered = false

        for (const item of items) {

            this._fetchLinkPreviewData(item.url, item.platform)
                .then((data) => {

                    // Remove skeletons when first item arrives
                    if (!firstItemRendered) {
                        firstItemRendered = true

                        const skeletons = renderCon.querySelectorAll('.promotedItemSkeleton')
                        skeletons.forEach(el => el.remove())
                    }

                    const html = generateHtml._generateItem(data, item)
                    renderCon.insertAdjacentHTML('beforeend', html)

                })
                .catch(() => {
                    console.warn("Failed preview:", item.url)
                })
        }
    }



    async _fetchLinkPreviewData(url, platform) {
        // const result = await firebase._NVPreviewAffiliatedItem({ url, platform });

        // return result

        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch {
                return false;
            }
        }

        try {

            if (!isValidUrl(url)) {
                throw new Error("Invalid URL");
            }

            // ⭐ STEP 1 — Resolve redirects first
            let finalUrl = url;

            try {
                const redirectRes = await fetch(url, {
                    method: "GET",
                    redirect: "follow"
                });

                finalUrl = redirectRes.url || url;

            } catch (e) {
                // If redirect resolving fails, continue with original URL
                finalUrl = url;
            }

            // ⭐ STEP 2 — Call Microlink with resolved URL
            const response = await fetch(
                `https://api.microlink.io?url=${encodeURIComponent(finalUrl)}&screenshot=false`
            );

            if (!response.ok) {
                throw new Error("Microlink request failed");
            }

            const res = await response.json();

            if (!res || res.status !== "success") {
                throw new Error("Microlink failed");
            }

            const data = res.data;

            // ⭐ STEP 3 — Smarter image fallback logic
            const image =
                data.image?.url ||
                data.images?.find(img => img?.url)?.url ||
                data.logo?.url ||
                data.favicon ||
                null;

            return {
                success: true,
                platform,
                url: finalUrl,
                title: data.title || "",
                description: data.description || "",
                image
            };

        } catch (error) {

            return {
                success: false,
                platform,
                url,
                error: error.message
            };

        }
    }

    async _fetchLinkPreviewDataV1(url, platform) {

        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch {
                return false;
            }
        }


        try {

            if (!isValidUrl(url)) {
                throw new Error("Invalid URL");
            }

            const response = await fetch(
                `https://api.microlink.io?url=${encodeURIComponent(url)}`
            );

            const res = await response.json();

            if (!res || res.status !== "success") {
                throw new Error("Microlink failed");
            }

            const data = res.data;

            return {
                success: true,
                platform,
                url,
                title: data.title || "",
                description: data.description || "",
                image:
                    data.image?.url ||
                    data.images?.[0]?.url ||
                    null
            };

        } catch (error) {
            return {
                success: false,
                platform,
                url,
                error: error.message
            };
        }
    }




    _renderAffiliatedItems(containerId, items = []) {
        const container = document.getElementById(containerId);
        if (!container || !Array.isArray(items)) return;

        container.innerHTML = "";

        items.forEach(item => {
            if (!item?.url) return;

            if (!isValidUrl(item.url)) return;

            if (item.platform === "mercado-libre" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);

                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }

            // For now i just have all mercado libre items on my database
            if (item.platform === "amazon" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);

                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }
            // For now i just have all mercado libre items on my database
            if (item.platform === "ebay" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);

                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }
        });

        /* -------------------- MERCADOLIBRE -------------------- */

        function fetchMercadoLibrePreview(url, itemContainer) {
            fetch(`https://api.microlink.io?url=${encodeURIComponent(url)}`)
                .then(res => res.json())
                .then(res => {
                    if (!res || res.status !== "success") {
                        throw new Error("Microlink failed");
                    }
                    renderMercadoLibrePreview(itemContainer, res.data, url);
                })
                .catch(err => {
                    console.error("ML preview error:", err);
                    itemContainer.innerHTML = `
                    <div class="link-preview-error">
                        No se pudo cargar la vista previa
                    </div>
                `;
                });
        }

        function renderMercadoLibrePreview(container, data, url) {
            const image =
                data.image?.url ||
                data.images?.[0]?.url ||
                null;

            container.innerHTML = `
<div class="afItemMercadoLibreCon1">
  <div class="afItemMercadoLibreCon2">
    ${image ? `<img class="afItemMercadoLibreCon2Image" src="${image}" alt="Producto Mercado Libre">` : ""}
  </div>
  <div class="afItemMercadoLibreCon3">
    <div class="afItemMercadoLibreText1">
      ${escapeHtml(data.title || "Producto en Mercado Libre")}
    </div>
    <div class="afItemMercadoLibreText2">
      ${escapeHtml(data.description || "")}
    </div>
  </div>
  <div class="afItemMercadoLibreCon4">
    <a
      href="${url}"
      target="_blank"
      rel="noopener noreferrer"
      class="afItemMercadoLibreButtonOpenCon1 afItemMercadoLibreButtonOpenText1"
    >
      Comprar en Mercado Libre
    </a>
    <div class="afItemMercadoLibreButtonDeleteCon1">
      <div class="afItemMercadoLibreButtonDeleteText1">Delete</div>
    </div>
  </div>
</div>
        `;
        }

        /* -------------------- HELPERS -------------------- */

        function isMercadoLibreSecLink(url) {
            try {
                const u = new URL(url);
                let isMercadoLibre = false
                if (u.hostname.includes("mercadolibre.") && u.pathname.startsWith("/sec/")) {
                    isMercadoLibre = true
                }
                if (u.hostname.includes("meli.la")) {
                    isMercadoLibre = true
                }

                return isMercadoLibre
            } catch {
                return false;
            }
        }

        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch {
                return false;
            }
        }

        function showLoading(container) {
            container.innerHTML = `
            <div class="link-preview-loading">
                Cargando vista previa…
            </div>
        `;
        }

        function escapeHtml(text) {
            const div = document.createElement("div");
            div.textContent = text;
            return div.innerHTML;
        }
    }


}

export default new promotedItems()